var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasFolders || _vm.isHKlandUser
    ? _c(
        "div",
        { staticClass: "submissions__topbar" },
        [
          _c("HKLLeftRight", {
            scopedSlots: _vm._u(
              [
                _vm.hasFolders
                  ? {
                      key: "left",
                      fn: function () {
                        return [
                          !_vm.isAllCollapsed
                            ? _c(
                                "HKLButton",
                                {
                                  attrs: { color: "orange" },
                                  on: {
                                    click: function () {
                                      return _vm.collapseAll()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(_vm.$t("collapseAll")) +
                                      "\n      "
                                  ),
                                ]
                              )
                            : _c(
                                "HKLButton",
                                {
                                  attrs: { color: "darkblue" },
                                  on: {
                                    click: function () {
                                      return _vm.expandAll()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(_vm.$t("expandAll")) +
                                      "\n      "
                                  ),
                                ]
                              ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.isHKlandUser
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "Sticky",
                            {
                              attrs: {
                                align: "right",
                                stickyTop: 40,
                                specifyWidth: "auto",
                              },
                            },
                            [
                              !_vm.isStarted && _vm.canStartGreenFitout
                                ? _c(
                                    "HKLButton",
                                    {
                                      attrs: { color: "orange" },
                                      on: { click: _vm.openAddFoldersModal },
                                    },
                                    [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm.$t(
                                              "tenantProjects.greenFitOut.allowStart"
                                            )
                                          ) +
                                          "\n        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isStarted
                                ? [
                                    !_vm.isCompleted && _vm.canOnHold
                                      ? _c("HKLButton", {
                                          attrs: {
                                            color: "darkblue",
                                            action: "onHold",
                                            disabled: _vm.submission.onHold,
                                          },
                                          on: {
                                            click: function () {
                                              return _vm.openOnHoldModal()
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isUnderReview
                                      ? [
                                          _vm.canCommentOnGreenFitout &&
                                          _vm.isCurrentReviewer
                                            ? _c("HKLButton", {
                                                attrs: {
                                                  color: "darkblue",
                                                  action: "cancelLetter",
                                                },
                                                on: {
                                                  click: _vm.openCancelModal,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.canCommentOnGreenFitout &&
                                          _vm.isCurrentReviewer
                                            ? _c("HKLButton", {
                                                attrs: {
                                                  color: "darkblue",
                                                  action: "save",
                                                },
                                                on: {
                                                  click: function () {
                                                    return _vm.saveLetter()
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.canPreview
                                            ? _c("HKLButton", {
                                                attrs: {
                                                  color: "orange",
                                                  action: _vm.canSend
                                                    ? "preview_send"
                                                    : "preview",
                                                },
                                                on: { click: _vm.previewSend },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.canCommentOnGreenFitout ||
                                          _vm.canSend
                                            ? _c("HKLButton", {
                                                attrs: {
                                                  color: "orange",
                                                  action: "nextReviewer",
                                                },
                                                on: {
                                                  click: _vm.nextReviewers,
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isDraft && _vm.canStartGreenFitout
                                      ? _c(
                                          "HKLButton",
                                          {
                                            attrs: { color: "orange" },
                                            on: {
                                              click: _vm.openAddFoldersModal,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "tenantProjects.greenFitOut.addFolder"
                                                  )
                                                ) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
          _vm._v(" "),
          _c("AddFolders", { ref: "addFoldersRef" }),
          _vm._v(" "),
          _c("HKLModal", {
            ref: "cancelModal",
            attrs: {
              title: _vm.$t("tenantProjects.greenFitOut.cancelAlert"),
              okBtnAction: "yes",
              cancelBtnAction: "no",
            },
            on: { onOkClick: _vm.cancelLetter },
          }),
          _vm._v(" "),
          _c("GreenFitOutOnHoldModal", { ref: "onHoldModal" }),
          _vm._v(" "),
          _c("GreenFitOutNextReviewModal", { ref: "nextReviewModal" }),
          _vm._v(" "),
          _vm.isUnderReview
            ? _c("GreenFitOutPreviewSendModal", {
                ref: "previewSendModal",
                attrs: { previewData: _vm.previewData },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }